module.exports = __webpack_public_path__ + "media/img/user-2-96648cb4.png";